export default __webpack_public_path__ + "static/iconjar2-8-76612550e730b17e428bd0f69fd3e879.mp4";